import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const productosAlCostoPdf = (data) => {
  const { orden, empresa } = data;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const ordenConfirmada = orden.estado === 3;
  // Solo tiene sentido mientras la orden sigue por confirmar: al confirmarla el
  // apartado se consume y regresa a 0.
  const mostrarApartado = !ordenConfirmada && (orden.insumos || []).some(
    (item) => Number(item.apartado || 0) > 0
  );

  const layoutTabla = {
    hLineWidth: (i) => 1,
    vLineWidth: (i) => 1,
    hLineColor: () => "#e8e8e8",
    vLineColor: () => "#e8e8e8",
    fillColor: (rowIndex) => (rowIndex % 2 === 0 ? '#f9f9f9' : null)
  };

  const estiloHeaderTabla = { bold: true, fontSize: 10, color: 'black', fillColor: '#dedede', margin: [5, 5, 5, 5] };
  const estiloCelda = { fontSize: 10, margin: [5, 5, 5, 5] };

  // --- TABLA DE INSUMOS ---
  const tableHeader = [
    { text: 'Clave', style: estiloHeaderTabla },
    { text: 'Insumo', style: estiloHeaderTabla },
    { text: 'Cant. Proyecto', style: estiloHeaderTabla, alignment: 'right' },
    { text: 'Cant. a Costo', style: estiloHeaderTabla, alignment: 'right' },
  ];
  if (mostrarApartado) {
    tableHeader.push({ text: 'Apartado', style: estiloHeaderTabla, alignment: 'right' });
  }
  if (ordenConfirmada) {
    tableHeader.push({ text: 'Costo', style: estiloHeaderTabla, alignment: 'right' });
  }

  const tableBody = [tableHeader];

  orden.insumos.forEach(item => {
    const fila = [
      { text: item.clave || '-', style: estiloCelda },
      { text: item.nombreInsumo || 'Insumo sin nombre', style: estiloCelda },
      { text: item.cantidadProyecto || 0, style: estiloCelda, alignment: 'right' },
      { text: item.cantidad || 0, style: estiloCelda, alignment: 'right' },
    ];
    if (mostrarApartado) {
      fila.push({ text: item.apartado || 0, style: estiloCelda, alignment: 'right' });
    }
    if (ordenConfirmada) {
      fila.push({ text: dineroDisabledMask(item.costo || 0), style: estiloCelda, alignment: 'right' });
    }
    tableBody.push(fila);
  });

  var dd = {
    content: [
      // HEADER EMPRESA
      {
        style: 'tableExample',
        table: {
          widths: ['20%', '50%', '30%'],
          layout: 'noBorders',
          body: [[...HeaderEmpresaCard(empresa, mostrarRegimen, false, {
            border: [false, false, false, false],
            table: {
              headerRows: 1,
              widths: ['100%'],
              body : [
                [{ text: 'N° Orden:', style: 'subheader', alignment: 'center' }],
                [{ text: orden.numero || '-', style: 'textoChico', alignment: 'center' }],
                [{ text: 'Generado:', style: 'subheader', alignment: 'center' }],
                [{ text: moment().format('DD/MM/YYYY'), style: 'subheader', alignment: 'center' }],
              ]
            },
            layout: 'noBorders'
          })]]
        }
      },

      // TÍTULO
      { 
        text: `Orden de Productos al Costo N° ${orden.numero || '-'}`, 
        style: 'tituloPrincipal', 
        alignment: 'left',
        margin: [0, 5, 0, 10] 
      },

      // INFO GENERAL
      {
        style: 'tableExample',
        margin: [0, 0, 0, 15],
        table: {
          widths: ['20%', '30%', '20%', '30%'],
          body: [
            [
              { text: 'Proyecto', style: estiloHeaderTabla },
              { text: orden.proyectoId?.nombre || 'N/A', style: estiloCelda },
              { text: 'Referencia', style: estiloHeaderTabla },
              { text: orden.referencia || 'N/A', style: estiloCelda }
            ]
          ]
        }
      },

      { text: 'Detalle de Insumos', style: 'tableHeaderIzquierda', margin: [0, 0, 0, 5] },
      {
        table: {
          widths: ordenConfirmada
            ? ['12%', '38%', '16%', '16%', '18%']
            : (mostrarApartado
              ? ['12%', '40%', '16%', '16%', '16%']
              : ['15%', '50%', '17.5%', '17.5%']),
          body: tableBody
        },
        layout: layoutTabla,
        margin: [0, 0, 0, 15]
      },

      // FIRMAS
      {
        margin: [0, 60, 0, 0],
        stack: [
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1 }] },
          { text: 'Firma de Autorización', style: 'textoChico', alignment: 'center', margin: [0, 5, 0, 0] }
        ],
        alignment: 'center'
      }
    ],
    watermark: orden.estado === 0 ? { text: 'CANCELADA', color: 'gray', opacity: 0.15, bold: true, angle: 45 } : null,
    images: { logo: empresa.logo?.base64Completa ? empresa.logo.base64Completa : '' },
    styles: {
      tituloPrincipal: { fontSize: 16, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableHeaderIzquierda: { bold: true, fontSize: 14 },
      textoChico: { fontSize: 8 },
      tableExample: { margin: [0, 5, 0, 5] }
    },
    pageSize: 'LETTER',
    pageMargins: [40, 40, 40, 40]
  };

  return dd;
};

export default productosAlCostoPdf;